export default __webpack_public_path__ + "static/media/6 a.47f5c011.png";